import React, {Component} from 'react';
import {connect} from 'react-redux';
import * as actions from '../store/actions'

class permissionsManagement extends Component {
    state={
        profile: ''
    };

    componentDidMount(){
        this.props.onFetchAllUsers();
        this.props.onFetchAllProfiles();
    }

    render(){
        //console.log(this.props.allUserEmails);
        //console.log(this.props.allUserProfiles);
        //console.log(this.props.allProfiles);



        let tableProfile = this.props.allUserProfiles.map((profile, j) => {
            return(
                <tr key={j}>
                    <td>
                        <div className="dropdown">
                            <button className="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton"
                                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                {profile.name}
                            </button>
                            <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                <a className="dropdown-item">

                                </a>

                            </div>
                        </div>
                    </td>
                </tr>
            )
        });

        let tableEmail = this.props.allUserEmails.map((email, i) => {
            return(
                <tr key={i}>
                    <td>
                        <h6>{email.email}</h6>
                        {tableProfile[i]}
                    </td>
                </tr>
            )
        });

/*        let table = this.props.allUserProfiles.map((name,  i) =>  {
            return (
                <tr key={i}>
                    <td>{name.email}</td>
                    <td>
                        <div className="dropdown">
                            <button className="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton"
                                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                {name.name}
                            </button>
                            <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                <a className="dropdown-item">

                                </a>

                            </div>
                        </div>


                    </td>
                </tr>
            )
        });*/

        return(
            <div className="container mt-6 col-12">
                <h3 className="text-center text-secondary mb-5">Gerir Permissões de utilizadores</h3>
                <table className="table table-striped">
                    <thead>
                        <tr>
                            <th scope="col">E-Mail e Perfil</th>
                        </tr>
                    </thead>
                    <tbody>
                        {tableEmail}
                    </tbody>
                </table>


               {/* <table className="table table-striped">
                    <thead>
                    <tr>
                        <th scope="col">E-Mail</th>
                        <th scope="col">Perfil</th>
                    </tr>
                    </thead>
                    <tbody>
                    {tableEmail}
                    {tableProfile}
                    </tbody>
                </table>*/}
            </div>
        )
    }
}

const mapStateToProps = state =>{
    return{
        allUserProfiles: state.admin.allUserProfiles,
        allUserEmails: state.admin.allUserEmails,
        allProfiles: state.admin.allProfiles
    }
};

const mapDispatchToProps = dispatch => {
  return{
      onFetchAllUsers : () => dispatch(actions.allUserProfiles()),
      onFetchAllProfiles : () => dispatch(actions.allProfiles())
  }
};



export default connect(mapStateToProps, mapDispatchToProps)(permissionsManagement);



// WEBPACK FOOTER //
// ./src/containers/permissionsManagement.js